import React from "react";
import {useTranslation} from "react-i18next";
import {addDays, startOfDay, endOfDay} from "date-fns";

import Stack from "@mui/material/Stack";
import MDButton from "materialDashboard/components/MDButton";
import {formatISODate} from "../../../utils/date";


const DatesPreselected = ({dateGte, dateLte, setDateGte, setDateLte, ...props}) => {
    const {t} = useTranslation("inputs");

    const today = new Date();

    const handle1DaySelection = () => {
        setDateLte(endOfDay(today));
        setDateGte(startOfDay(today));
    }

    const handle2DaysSelection = () => {
        setDateLte(endOfDay(today));
        setDateGte(startOfDay(addDays(today, -1)));
    }

    const handle7DaysSelection = () => {
        setDateLte(endOfDay(today));
        setDateGte(startOfDay(addDays(today, -7)));
    }

    const handle30DaysSelection = () => {
        setDateLte(endOfDay(today));
        setDateGte(startOfDay(addDays(today, -30)));
    }


    const dateLteISO = formatISODate(dateLte);
    const dateGteISO = formatISODate(dateGte);
    const todayEndISO = formatISODate(endOfDay(today));

    const is1DaySelected = dateLteISO === todayEndISO && dateGteISO === formatISODate(startOfDay(today));
    const is2DaysSelected = dateLteISO === todayEndISO && dateGteISO === formatISODate(startOfDay(addDays(today, -1)));
    const is7DaysSelected = dateLteISO === todayEndISO && dateGteISO === formatISODate(startOfDay(addDays(today, -7)));
    const is30DaysSelected = dateLteISO === todayEndISO && dateGteISO === formatISODate(startOfDay(addDays(today, -30)));

    return <Stack direction="row" spacing={0.5} justifyContent="flex-end" alignItems="center" {...props}  >
        <MDButton color="info" variant={is1DaySelected ? "contained" : "outlined"} onClick={handle1DaySelection}
                  size="small">
            {t("datesPreselected.last1Day")}
        </MDButton>
        <MDButton color="info" variant={is2DaysSelected ? "contained" : "outlined"} onClick={handle2DaysSelection}
                  size="small">
            {t("datesPreselected.last2Days")}
        </MDButton>
        <MDButton color="info" variant={is7DaysSelected ? "contained" : "outlined"} onClick={handle7DaysSelection}
                  size="small">{t("datesPreselected.last7Days")}
        </MDButton>
        <MDButton color="info" variant={is30DaysSelected ? "contained" : "outlined"} onClick={handle30DaysSelection}
                  size="small">{t("datesPreselected.last30Days")}
        </MDButton>
    </Stack>
}

export default DatesPreselected;